import { render, staticRenderFns } from "./top.vue?vue&type=template&id=7024c6a2&scoped=true"
import script from "./top.vue?vue&type=script&lang=js"
export * from "./top.vue?vue&type=script&lang=js"
import style0 from "./top.vue?vue&type=style&index=0&id=7024c6a2&lang=less"
import style1 from "./top.vue?vue&type=style&index=1&id=7024c6a2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7024c6a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7024c6a2')) {
      api.createRecord('7024c6a2', component.options)
    } else {
      api.reload('7024c6a2', component.options)
    }
    module.hot.accept("./top.vue?vue&type=template&id=7024c6a2&scoped=true", function () {
      api.rerender('7024c6a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/designCategory/layout/top.vue"
export default component.exports